import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/** Live season state — polled every 30s. */
export function useSeason() {
  const [season, setSeason] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const { data } = await api.get("/season/current");
        if (!cancelled) setSeason(data);
      } catch {
        /* ignore */
      }
    };
    load();
    const id = setInterval(load, 30000);
    return () => { cancelled = true; clearInterval(id); };
  }, []);

  return season;
}
